// Module
var code = "<td class=\"timewriting-table-column__value yesNo\"> <input type=\"checkbox\" data-bind=\"checked: _cell.Value, uniform: _cell.Value\" disabled=\"disabled\"/> </td>";
// Exports
export default code;